import { useState, useEffect, useCallback } from "react";
import { createTicketsApi, type Ticket, type ListTicketsParams } from "../api/tickets";

export function useTickets(token: string, workspaceId: string | null, params: ListTicketsParams) {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const paramsKey = JSON.stringify(params);

  const load = useCallback(async () => {
    if (!token || !workspaceId) return;
    setLoading(true);
    setError(null);
    try {
      const api = createTicketsApi(token, workspaceId);
      const result = await api.list(params);
      setTickets(result.tickets);
      setTotal(result.pagination?.total ?? result.tickets.length);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load tickets");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, workspaceId, paramsKey]);

  useEffect(() => { load(); }, [load]);

  return { tickets, total, loading, error, refresh: load };
}
